import { render } from "./AddSiteView.vue?vue&type=template&id=b05a1d18"
import script from "./AddSiteView.vue?vue&type=script&lang=js"
export * from "./AddSiteView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__